import { cn } from '@/lib/cn.ts'

/**
 * The large blurred organic shapes that give Material You its atmosphere.
 *
 * Purely decorative, so the whole layer is `aria-hidden` and non-interactive.
 * Shapes sit partly off-canvas and use `mix-blend-multiply` so overlaps deepen
 * in colour rather than washing out.
 */
export function DecorativeBlobs({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}
    >
      <div className="decorative-blob -left-24 -top-32 size-96 rounded-full bg-primary-container opacity-60" />
      <div className="decorative-blob -right-32 top-1/4 size-[28rem] rounded-[100px] rounded-tr-[20px] bg-tertiary-container opacity-50" />
      <div className="decorative-blob -bottom-40 left-1/3 size-[24rem] rounded-full bg-secondary-container opacity-50" />
    </div>
  )
}

/** A softer single wash, for the inside of a section rather than a whole page. */
export function GlowBackdrop({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-primary-container)_0%,transparent_55%)] opacity-60',
        className,
      )}
    />
  )
}
